import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Button from '../../components/Button';

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: ${(props) => props.theme.colors.background || '#f5f5f5'};
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0 16px;
  }
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 20px 0;

  @media (max-width: 768px) {
    padding: 16px 0;
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  svg {
    color: ${(props) => props.theme.colors.text.secondary || '#666'};
  }
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 500px;
  margin: 0 auto;
  width: 100%;
  padding: 20px 0;

  @media (max-width: 768px) {
    padding: 16px 0;
    justify-content: flex-start;
    margin-top: 20px;
  }
`;

export const Title = styled.h1`
  font-family: 'Unimed-Sans-Regular', sans-serif;
  font-size: 1.35rem;
  line-height: 1.4;
  color: ${(props) => props.theme.colors.text.primary || '#333'};
  text-align: center;
  margin-bottom: 40px;
  font-weight: 400;

  strong {
    font-family: 'Unimed-Sans-Bold', sans-serif;
    font-weight: 700;
  }

  @media (max-width: 768px) {
    font-size: 1.3rem;
    margin-bottom: 32px;
    padding: 0 16px;
  }

  @media (max-width: 480px) {
    font-size: 1.2rem;
    margin-bottom: 24px;
  }
`;

export const FormContainer = styled.div`
  width: 100%;
  margin-bottom: 40px;

  form {
    display: flex;
    flex-direction: column;
    gap: 24px;

    > div {
      display: flex;
      flex-direction: column;
      gap: 8px;

      label {
        font-family: 'Unimed-Sans-SemiBold', sans-serif;
        font-size: 1rem;
        color: ${(props) => props.theme.colors.text.primary || '#333'};
        font-weight: 600;
      }
    }
  }

  @media (max-width: 768px) {
    margin-bottom: 32px;

    form {
      gap: 20px;
    }
  }
`;

export const ViewCardButton = styled(Button)`
  width: 100%;
  margin-top: 16px;
  padding: 16px;
  font-size: 1.1rem;
  font-family: 'Unimed-Sans-SemiBold', sans-serif;
  background-color: ${(props) =>
    props.theme.colors.palet.institutional || '#00995D'};
  border-radius: 24px;
  border: none;
  color: white;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover:not(:disabled) {
    background-color: ${(props) =>
      props.theme.colors.palet.institutional2 || '#00401A'};
    transform: translateY(-1px);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    background-color: ${(props) =>
      props.theme.colors.palet.institutional || '#00995D'};
    opacity: 0.8;
    cursor: not-allowed;
    transform: none;
  }

  @media (max-width: 768px) {
    padding: 14px;
    font-size: 1rem;
    border-radius: 20px;
  }
`;

export const LoadingSpinner = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid transparent;
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-right: 8px;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const FooterText = styled.p`
  font-family: 'Unimed-Sans-Regular', sans-serif;
  font-size: 1rem;
  color: ${(props) => props.theme.colors.text.secondary || '#666'};
  text-align: center;
  line-height: 1.4;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    font-size: 0.9rem;
    margin-bottom: 32px;
    padding: 0 16px;
  }

  @media (max-width: 480px) {
    font-size: 0.85rem;
  }
`;

export const AppLoginLink = styled(Link)`
  color: ${(props) => props.theme.colors.palet.institutional || '#00995D'};
  text-decoration: underline;
  font-family: 'Unimed-Sans-SemiBold', sans-serif;
  font-weight: 600;
  transition: color 0.2s;

  &:hover {
    color: ${(props) => props.theme.colors.palet.institutional2 || '#00401A'};
  }

  &:visited {
    color: ${(props) => props.theme.colors.palet.institutional || '#00995D'};
  }
`;
